import React from "react";
import { Navigate } from "react-router-dom";
import ProductDetail from "../page/ProductDetail";

const PrivateRoute = ({ authenticate }) => {
  return authenticate ? <ProductDetail /> : <Navigate to="/login" />;
};

export default PrivateRoute;
